import {Hotel} from 'modules/sapiSearch/slice'

const EARTH_RADIUS_KM = 6371

/** Haversine distance preserves zero coordinates; Core calculateDistance treats them as missing. */
export const getDistanceKm = (a: Hotel['_geoloc'], b: Hotel['_geoloc']) => {
  if (
    ![a?.lat, a?.lon, b?.lat, b?.lon].every(Number.isFinite) ||
    Math.abs(a.lat) > 90 ||
    Math.abs(b.lat) > 90 ||
    Math.abs(a.lon) > 180 ||
    Math.abs(b.lon) > 180
  )
    return undefined

  const radians = (degrees: number) => (degrees * Math.PI) / 180
  const halfChord =
    Math.sin(radians(b.lat - a.lat) / 2) ** 2 +
    Math.cos(radians(a.lat)) *
      Math.cos(radians(b.lat)) *
      Math.sin(radians(b.lon - a.lon) / 2) ** 2

  return EARTH_RADIUS_KM * 2 * Math.asin(Math.sqrt(Math.min(1, halfChord)))
}
